import { CustomReportRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ReportsCustomReportRoute() {
  const { workspaceId, reportId } = Route.useParams();
  return <CustomReportRoute segment="reports" workspaceId={workspaceId} reportId={reportId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/reports/custom-reports/$reportId')({
  component: ReportsCustomReportRoute,
});
